import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import axios from 'axios';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { IssueDocs } from './IssueDocs';
import { IssueMessage } from './IssueMessage';
import { IssueReference } from './IssueReference';
import { withAutoFixModal } from './AutoFixModal';
import filterProps from '../../../utils/filterProps';
import toolRuleLinker from '../../../utils/tool-rule-linker';
class Issue extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            docsLoading: false,
            docsExpanded: false,
            docs: '',
        };
        this.handleToggleDocs = (event, tool, ruleId) => {
            if (event) {
                event.preventDefault();
            }
            if (!this.state.docs) {
                this.setState((prevState) => {
                    return {
                        docsExpanded: !prevState.docsExpanded,
                        docsLoading: true,
                    };
                }, () => this._loadDocs(`${tool}/${ruleId.replace('@typescript-eslint', 'typescript-eslint').replaceAll(' ', '')}`));
            }
            else {
                this.setState((prevState) => {
                    return {
                        docsExpanded: !prevState.docsExpanded,
                    };
                });
            }
            if (this.props.onIssueExpandClick) {
                this.props.onIssueExpandClick(this.state.docsExpanded);
            }
        };
        this.handleScrollToLine = (event, target) => {
            event.preventDefault();
            let element = document.getElementById(target);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            else {
                target = target.replace(/:[0-9]+/, '');
                element = document.getElementById(target);
                if (element) {
                    // @todo: maybe automatically load not-loaded file?
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }
        };
    }
    _loadDocs(docsPath) {
        return axios
            .get(`/issues/${docsPath}.html`)
            .then((response) => {
            this.setState({
                docsLoading: false,
                docs: response.data,
            });
        })
            .catch((error) => {
            console.error(error);
        });
    }
    render() {
        const { issue, extension, onShowDetailClick, ...rest } = filterProps(this.props, [
            'onIssueExpandClick',
            'i18n',
            'lng',
            't',
            'tReady',
        ]);
        const { isError, tool, toolVersion, ruleId, message, autoFix, options, nodeType } = issue;
        const plugin = issue.ruleId ? issue.ruleId.split('/') : '';
        const showDocs = this.state.docsExpanded || this.state.docsLoading;
        const href = toolRuleLinker(tool, toolVersion, ruleId || '', nodeType || '', 
        // @ts-expect-error TS2345: Argument of type 'string[] | ""' is not assignable to parameter of type 'string[] | null | undefined'.
        plugin.length !== 1 ? plugin : [], options);
        const hasReference = ruleId && !(tool === 'sass-lint' && ruleId === 'Fatal');
        const iconName = isError ? 'exclamation-circle' : 'exclamation-triangle';
        const iconColor = isError ? 'text-danger' : 'text-warning';
        const iconClasses = clsx('issue__icon', `icon--${iconName} ${iconColor}`);
        return _jsxs("div", { ...rest, children: [_jsx("span", { className: iconClasses }), hasReference ? _jsx(IssueReference, { tool: tool, href: href, ruleId: ruleId, showDocs: showDocs, onToggleDocs: this.handleToggleDocs }) : null, _jsx("span", { className: "report-detail__message", children: _jsx(IssueMessage, { message: message, ruleId: ruleId, tool: tool, options: options, handleScrollToLine: this.handleScrollToLine }) }), showDocs ? _jsx(IssueDocs, { docs: this.state.docs, tool: tool, toolVersion: toolVersion, href: href, ruleId: ruleId, loading: this.state.docsLoading }) : null] });
    }
}
export default withAutoFixModal(withTranslation()(Issue));
